const $ = window.jQuery;

import tippy from 'tippy.js';
import { delegate } from 'tippy.js';

if( $('.is-tooltip-content' ).length !== 0 ) {

  $('.is-tooltip-content').parent().append('<i class="fas fa-question-circle"></i>');
  
  $('.is-tooltip-content + .fa-question-circle').each(function(index, element) {
    tippy(element, {
      content: $(this).siblings('.is-tooltip-content').text(),
      placement: 'right',
    })
  })

/* 
  delegate('td', {
      target: '.is-tooltip-content',
      placement: 'right',
  });
 */
}